import { Dropdown } from "flowbite-react";
import "../../../Assets/Css/Doctors/Dashboard.css";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosClient from "../../../AxiosClient";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Redux/SliceAuthDoctor";
import { remove } from "../../../Services/LocalStorageService";
import GetAuthDoctor from "../../../hooks/GetAuthDoctor";

const NavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const doctorData = useSelector((state) => state.AuthDoctor);

  GetAuthDoctor();

  const Logout = () => {
    axiosClient
      .post("/doctor/logout")
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // Always clear the local session, even if the server call fails
        dispatch(logout());
        remove("TOKEN_DOCTOR");
        navigate("/");
      });
  };

  return (
    <>
      <nav className="fixed z-30 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
        <div className="px-3 py-3 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start">
              <Link to={"/"} className=" flex ml-2 md:mr-24">
                  <img width={100} src="/img/final-logo.png" className="logo_nav" alt="Logo" />
              </Link>
            </div>
            <div className="flex items-center gap-3">
              <Dropdown
                arrowIcon={false}
                inline={true}
                label={
                  <div>
                    <div
                      type="button"
                      className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                    >
                      <span className="sr-only">Open user menu</span>
                      <img
                        className="w-8 h-8 rounded-full object-cover"
                        src={doctorData?.doctor?.avatar_doctor || process.env.PUBLIC_URL + "/img/doc-image.jpg"}
                        alt="Doctor profile"
                      />
                    </div>
                  </div>
                }
                className="show-notif-Setting h-[12.4rem] "
              >
                {/* <!-- Dropdown menu --> */}
                <div className="z-50 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600">
                  <div className="px-4 py-3" role="none">
                    <p
                      className="text-sm text-gray-900 dark:text-white"
                      role="none"
                    >
                      {doctorData?.doctor?.firstname} {doctorData?.doctor?.lastname}
                    </p>
                    <p
                      className="text-sm font-medium text-gray-900 truncate dark:text-gray-300"
                      role="none"
                    >
                      {doctorData?.doctor?.email}
                    </p>
                  </div>
                  <ul className="py-1" role="none">
                    <li>
                      <Link
                        to={"/doctor/dashboard"}
                        className="block px-4 py-2 cursor-pointer text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/settings" role="menuitem"></Link>
                      <Link
                        to={"/doctor/settings"}
                        className="block px-4 py-2 text-sm cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Settings
                      </Link>
                    </li>
                    <Dropdown.Divider />
                    <li>
                      <div
                        className="block px-4 py-2 text-sm cursor-pointer text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                        role="menuitem"
                      >
                        <button onClick={Logout}>Sign out</button>
                      </div>
                    </li>
                  </ul>
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
